import { type SettingsTemplate, settingsTemplate } from './template'

export const ENV_KEY = 'local'

export const local: SettingsTemplate = {
  ...settingsTemplate,
  isLocal: true,

  DEPLOY_STORYBOOK: false,

  ENABLE_METRICS: true,

  // Allow all origins in local/development mode
  API_CORS_ALLOW_ORIGIN: '*',

  COMFYUI_AUTO_SHUTDOWN_IDLE_HOURS: 6,
  COMFYUI_USE_SPOT_INSTANCE: false,
  COMFYUI_SPOT_MAX_PRICE: '',
  DEPLOY_COMFYUI_EC2: false,

  ENABLE_CUSTOM_DOMAIN: false
}
